export default "__VITE_ASSET__Dvt4xbxF__"